/* 2026-09-16: 变换数值行 + 剪贴板（第一批 Batch B）
   ==================================================================
   两块内容，都是「专业设计板标配、本站此前完全没有」的东西：

   ① Transform 数值行（#pfmTransformSection）
      此前**全站没有任何 type="number"**（board/section 里计数为 0）—— 字号、尺寸、角度
      只能拖滑杆，拖不到精确值（字号 8~500 的范围里想设 137 基本不可能）。
      · W / H 用「**打印区的百分比**」而不是画布逻辑 px —— 画布是 3000²，px 对用户无意义；
        百分比无单位、永远成立，也贴合「这个 logo 占打印宽度的多少」的真实意图。
      · 改 W 或 H 一律**等比缩放**（不破坏图形比例）；改角度直接设 rotation。
      · 正在输入的框不参与回写（`document.activeElement` 判断），否则边打字边被覆盖。
      · 拖滑杆式的 live 预览不落快照；`change`（失焦/回车）才 `__pfmSaveState()`，
        与底栏 Size 滑杆的既有做法一致（fabric 的程序化 set 不会触发 object:modified）。

   ② 剪贴板 Ctrl+C / V / X
      · 跨面可用（同一 canvas 实例；配合既有切面逻辑即可「正面复制 → 背面粘贴」）。
      · 粘贴落位：整体偏移 4% 打印区；放不下则整体缩到 90% 并居中于打印区，放得下只做拉回。
      · X（剪切）复用 section 的 `__pfmDoAction('del')` —— **不写第二份删除逻辑**。
      · 键位在 section 既有的键盘块里分发（那里已有「输入框/弹窗/board 未开」的守卫，不重复写）。
*/
(function () {
  'use strict';

  function CV() { return window.__pfmCanvas || null; }
  function q(id) { return document.getElementById(id); }
  function toast(m) { try { if (window.__pfmToast) window.__pfmToast(m); } catch (e) { } }
  function r1(v) { return Math.round(v * 10) / 10; }
  function face() { return (window.__pfmGetPlacement && window.__pfmGetPlacement()) || 'front'; }

  /* 当前打印区规格（逻辑坐标 rect）。取不到时返回 null，调用方各自兜底。 */
  function spec() {
    var pa = window.__pfmPrintArea && window.__pfmPrintArea();
    if (!pa) return null;
    var s = pa[face()];
    if (!s) { var ks = Object.keys(pa); s = ks.length ? pa[ks[0]] : null; }
    return (s && s.width > 0 && s.height > 0) ? s : null;
  }
  function activeObj() {
    var c = CV(); if (!c) return null;
    var o = null; try { o = c.getActiveObject(); } catch (e) { }
    if (!o || o.isGrid || o.isPreview) return null;
    return o;
  }

  /* ============================================================ ① Transform */
  var editing = null;   /* 正在输入的 input（change 时清空） */

  function syncXf() {
    var sec = q('pfmTransformSection'); if (!sec) return;
    var o = activeObj();
    /* 多选时 W/H/角度 语义不明确 → 与「单个对象」保持一致，整行隐藏 */
    var single = !!(o && String(o.type) !== 'activeSelection');
    sec.style.display = single ? 'block' : 'none';
    syncShadow();          /* 对象投影行：多选时也要刷新，故放在提前返回之前 */
    if (!single) return;

    var sp = spec();
    var w = q('pfmXfW'), h = q('pfmXfH'), a = q('pfmXfA');
    if (sp) {
      if (w && editing !== w) w.value = r1(o.getScaledWidth() / sp.width * 100);
      if (h && editing !== h) h.value = r1(o.getScaledHeight() / sp.height * 100);
    }
    if (a && editing !== a) {
      /* 2026-09-19: 角度归一化到 -180~180。输入框 min/max 就是这个范围，而 o.angle 是任意值
         （fabric 不取模）⇒ 转 359° 时会把 359 写进框里、触发 HTML rangeOverflow（校验失败）。 */
      var ang = Math.round(o.angle || 0) % 360;
      if (ang > 180) ang -= 360;
      if (ang < -180) ang += 360;
      a.value = ang;
    }

    /* 字号行：仅文字（IText / Textbox / Text） */
    var isText = String(o.type || '').toLowerCase().indexOf('text') >= 0;
    var row = q('pfmXfSizeRow'); if (row) row.style.display = isText ? '' : 'none';
    var si = q('pfmXfSize');
    /* 2026-09-19: 非文字也清一次 —— 原来只在文字时回填，切回图片/形状后框里
       会留着上一个文字的字号（行虽隐藏，值仍在，同一输入框复用不干净）。 */
    if (si && editing !== si) si.value = isText ? Math.round(o.fontSize || 0) : '';
  }

  function scaleToPct(o, sp, pct, axis) {
    var cur = axis === 'h' ? o.getScaledHeight() : o.getScaledWidth();
    var full = axis === 'h' ? sp.height : sp.width;
    if (!(cur > 0) || !(full > 0)) return false;
    var k = (full * pct / 100) / cur;
    if (!isFinite(k) || k <= 0) return false;
    o.set({ scaleX: (o.scaleX || 1) * k, scaleY: (o.scaleY || 1) * k });   /* 等比 */
    if (o.setCoords) o.setCoords();
    return true;
  }

  /* 2026-09-20: 绕中心反算 —— **唯一实现**（角度 / W-H / Size 倍数滑杆三处共用，别再写第二份）。
     用法：调用方先 `var c0 = o.getCenterPoint()` → 改值 → 再 `recenter(o, c0)`。
     原因：fabric 对象原点在左上角（图片 left/top），直接改 scale/angle 会让图案整体位移。 */
  function recenter(o, c0) {
    if (!o || !c0) return;
    try {
      var c1 = o.getCenterPoint();
      o.set({ left: (o.left || 0) + (c0.x - c1.x), top: (o.top || 0) + (c0.y - c1.y) });
      if (o.setCoords) o.setCoords();
    } catch (e) { }
  }
  window.__pfmRecenter = recenter;

  function applyXf(kind, raw, commit) {
    var o = activeObj(); if (!o) return false;
    var v = parseFloat(raw);
    if (!isFinite(v)) { syncXf(); return false; }
    if (kind === 'a') {
      v = Math.max(-180, Math.min(180, v));
      /* 2026-09-19: 绕中心旋转 —— fabric 对象原点是左上角，直接 set('angle') 会绕着左上角转
         导致图案整体位移（用户报「角度要以中心为旋转点，不是左上角」）。
         做法：先记中心 -> 设角度 -> 反算 left/top 把中心拉回原处（幂等，滑杆连续输入也成立）。 */
      var _c0 = null; try { _c0 = o.getCenterPoint(); } catch (e) { }
      o.set('angle', v);
      if (o.setCoords) o.setCoords();
      recenter(o, _c0);   /* 见文件下方 recenter() —— 与 W/H、Size 滑杆共用同一套反算 */
    } else if (kind === 'size') {
      v = Math.max(8, Math.min(500, v));
      if (String(o.type || '').toLowerCase().indexOf('text') < 0) return false;
      o.set('fontSize', v);
    } else {
      var sp = spec(); if (!sp) return false;
      v = Math.max(1, Math.min(300, v));
      /* 2026-09-20: 绕中心缩放 —— fabric 对象原点是左上角，直接改尺寸会以左上角为基准
         （实测改 W 时 left/top 完全不变、中心漂移 −227px）。做法与角度一致：记中心 →
         缩放 → 反算 left/top 把中心拉回原处（幂等，连续输入与往复拖动都不累积）。 */
      var _sc0 = null; try { _sc0 = o.getCenterPoint(); } catch (e) { }
      if (!scaleToPct(o, sp, v, kind === 'h' ? 'h' : 'w')) return false;
      recenter(o, _sc0);   /* 同上 */
      /* 2026-09-19: 尺寸基准失效 —— 「Size」滑杆按基准算倍数（09-20 起基准是 `o._pfmS0={scaleX,scaleY}`，
         旧名 `_pfmW0` 一并清掉），这里改过尺寸后必须清，否则下次拖滑杆仍按旧基准（实测 379 → 1102 跳变）。 */
      try { delete o._pfmW0; } catch (e) { }
      try { delete o._pfmS0; } catch (e) { }
    }
    if (o.setCoords) o.setCoords();
    var c = CV(); if (c && c.renderAll) c.renderAll();
    if (commit) { try { if (window.__pfmSaveState) window.__pfmSaveState(); } catch (e) { } }
    return true;
  }

  function bindXf() {
    [['pfmXfW', 'w'], ['pfmXfH', 'h'], ['pfmXfA', 'a'], ['pfmXfSize', 'size']].forEach(function (it) {
      var el = q(it[0]);
      if (!el || el.__xf) return;
      el.__xf = true;
      el.addEventListener('input', function () { editing = el; applyXf(it[1], el.value, false); });
      el.addEventListener('change', function () { editing = null; applyXf(it[1], el.value, true); syncXf(); });
      el.addEventListener('blur', function () { editing = null; syncXf(); });
      /* 回车即提交（number 输入框不产生 change） */
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); el.blur(); }
      });
    });
  }

  /* ============================================================ ①b 对象投影（#5） */
  var SHADOW_KINDS = [['none', 'None'], ['soft', 'Soft'], ['hard', 'Hard'], ['glow', 'Glow'],
                      ['long', 'Long'], ['neon', 'Neon'], ['lift', 'Lift'], ['sunken', 'Sunken'],
                      ['cast', 'Cast'], ['retro', 'Retro'], ['extrude', 'Extrude'], ['deep', 'Deep'],
                      ['fog', 'Fog'], ['halo', 'Halo'], ['underlight', 'Underlight'], ['motion', 'Motion']];
  var shRendered = false;

  function shadowSec() { return q('pfmShadowSection'); }

  function renderShadow() {
    var sec = shadowSec(); if (!sec || shRendered) return;
    /* 手调控件由 hd-text.js 提供（defer 顺序：hd-edit 在前）⇒ 未就绪就不算渲染过，等下一轮 syncShadow */
    if (!window.__pfmShadowUI) return;
    shRendered = true;
    sec.innerHTML = ''
      + '<div class="pfm-row">'
      +   '<label class="pfm-label">Shadow</label>'
      +   '<div class="pfm-tx-seg pfm-sh-seg">'
      +     SHADOW_KINDS.map(function (k) {
              return '<button class="pfm-tx-chip" type="button" data-objsh="' + k[0] + '">' + k[1] + '</button>';
            }).join('')
      +   '</div>'
      + '</div>'
      + '<div class="pfm-sh-params" id="pfmShParams" style="display:none">'
      +   window.__pfmShadowUI.html('Sh')
      + '</div>';
    Array.prototype.forEach.call(sec.querySelectorAll('[data-objsh]'), function (b) {
      b.addEventListener('click', function () { applyShadow(b.dataset.objsh); });
    });
    window.__pfmShadowUI.bind('Sh', sec, applyShadowParams);
  }

  /* 手调参数：用滑杆的**绝对值**构造阴影（不走尺寸等比）—— 走引擎的 override 分支 */
  function applyShadowParams() {
    var c = CV(); if (!c) return;
    var tg = shadowTargets(); if (!tg.length) return;
    var api = window.__pfmShadow; if (!api || !api.for || !api.rgba) return;
    var ov = window.__pfmShadowUI.read('Sh');   /* 含 角度→X/Y 换算 */
    for (var i = 0; i < tg.length; i++) {
      try { tg[i].set('shadow', api.for(tg[i], null, ov)); if (tg[i].setCoords) tg[i].setCoords(); } catch (e) { }
    }
    c.renderAll();
    try { if (window.__pfmSaveState) window.__pfmSaveState(); } catch (e) { }
    syncShadow();
  }

  /* 目标：单个对象或多选下钻（与填充/描边同一套下钻规则） */
  function shadowTargets() {
    var c = CV(); if (!c) return [];
    var o = null; try { o = c.getActiveObject(); } catch (e) { }
    if (!o || o.isGrid || o.isPreview) return [];
    var out = [];
    (function push(x) {
      if (!x || x.isGrid || x.isPreview) return;
      if (x.type === 'group' || x.type === 'activeSelection') {
        (x.getObjects ? x.getObjects() : []).forEach(push); return;
      }
      out.push(x);
    })(o);
    return out;
  }

  function applyShadow(kind) {
    var c = CV(); if (!c) return;
    var tg = shadowTargets(); if (!tg.length) return;
    var api = window.__pfmShadow;
    if (!api || !api.for) { toast('Shadow engine not ready'); return; }
    for (var i = 0; i < tg.length; i++) {
      try { tg[i].set('shadow', api.for(tg[i], kind)); if (tg[i].setCoords) tg[i].setCoords(); } catch (e) { }
    }
    c.renderAll();
    try { if (window.__pfmSaveState) window.__pfmSaveState(); } catch (e) { }
    syncShadow();
  }

  function syncShadow() {
    var sec = shadowSec(); if (!sec) return;
    renderShadow();
    var o = activeObj();
    /* 单个文字对象 → 隐藏：它有自己的 Shadow 行在 Text 面板里，避免两处 UI 改同一属性 */
    var isTextSingle = !!(o && String(o.type).toLowerCase().indexOf('text') >= 0);
    sec.style.display = (o && !isTextSingle) ? 'block' : 'none';
    if (!o || isTextSingle) return;
    var api = window.__pfmShadow;
    var kind = null;
    if (String(o.type) !== 'activeSelection' && api && api.kindOf) kind = api.kindOf(o.shadow, o);
    Array.prototype.forEach.call(sec.querySelectorAll('[data-objsh]'), function (b) {
      b.classList.toggle('on', kind !== null && b.dataset.objsh === kind);
    });
    /* 参数行：多选或没有阴影时收起；否则从对象**实际的** shadow 反填颜色/透明度/距离/模糊 */
    var box = q('pfmShParams');
    var has = !!(String(o.type) !== 'activeSelection' && o.shadow && api && api.color);
    if (box) box.style.display = has ? 'block' : 'none';
    if (!has) return;
    window.__pfmShadowUI.sync('Sh', o.shadow);   /* 含 X/Y → 长度/角度 反算 */
  }

  /* ============================================================ ② 剪贴板 */
  var CLIP = null;

  function capture() {
    var o = activeObj(); if (!o) return null;
    var kids = (String(o.type) === 'activeSelection' && o.getObjects) ? o.getObjects().slice() : [o];
    var arr = [];
    for (var i = 0; i < kids.length; i++) {
      var x = kids[i];
      if (!x || x.isGrid || x.isPreview) continue;
      try { arr.push(x.toObject()); } catch (e) { }
    }
    return arr.length ? arr : null;
  }

  function count(n) { return n + (n === 1 ? ' object' : ' objects'); }

  function doCopy(cut) {
    var arr = capture();
    if (!arr) { toast('Nothing selected'); return false; }
    CLIP = arr;
    if (cut) {
      /* 复用 section 的删除实现（它已处理多选下钻 / 面板刷新），不写第二份 */
      if (window.__pfmDoAction) { try { window.__pfmDoAction('del'); } catch (e) { } }
      toast('Cut ' + count(arr.length));
    } else {
      toast('Copied ' + count(arr.length));
    }
    return true;
  }

  function bbox(list) {
    var l = Infinity, t = Infinity, r = -Infinity, b = -Infinity;
    list.forEach(function (o) {
      if (o.setCoords) o.setCoords();
      var bb = o.getBoundingRect(true, true);
      l = Math.min(l, bb.left); t = Math.min(t, bb.top);
      r = Math.max(r, bb.left + bb.width); b = Math.max(b, bb.top + bb.height);
    });
    return { l: l, t: t, r: r, b: b, w: r - l, h: b - t };
  }

  function doPaste() {
    if (!CLIP || !CLIP.length) { toast('Clipboard is empty'); return false; }
    var c = CV(); if (!c) { toast('Canvas not ready'); return false; }
    var sp = spec();
    fabric.util.enlivenObjects(CLIP, function (objs) {
      if (!objs || !objs.length) { toast('Paste failed'); return; }
      var dx = sp ? sp.width * 0.04 : 24, dy = sp ? sp.height * 0.04 : 24;
      objs.forEach(function (o) { o.set({ left: (o.left || 0) + dx, top: (o.top || 0) + dy }); });

      if (sp) {
        var bb = bbox(objs);
        if (bb.w > sp.width * 0.98 || bb.h > sp.height * 0.98) {
          /* 放不下 → 整体缩到 90% 并居中 */
          var k = Math.min(sp.width * 0.9 / bb.w, sp.height * 0.9 / bb.h);
          if (isFinite(k) && k > 0) {
            objs.forEach(function (o) { o.set({ scaleX: (o.scaleX || 1) * k, scaleY: (o.scaleY || 1) * k }); });
          }
          bb = bbox(objs);
          var ox = (sp.left + sp.width / 2) - (bb.l + bb.w / 2);
          var oy = (sp.top + sp.height / 2) - (bb.t + bb.h / 2);
          objs.forEach(function (o) { o.set({ left: (o.left || 0) + ox, top: (o.top || 0) + oy }); });
        } else {
          /* 放得下 → 只把整体拉回打印区内 */
          var sx = 0, sy = 0;
          if (bb.l < sp.left) sx = sp.left - bb.l;
          else if (bb.r > sp.left + sp.width) sx = (sp.left + sp.width) - bb.r;
          if (bb.t < sp.top) sy = sp.top - bb.t;
          else if (bb.b > sp.top + sp.height) sy = (sp.top + sp.height) - bb.b;
          if (sx || sy) objs.forEach(function (o) { o.set({ left: (o.left || 0) + sx, top: (o.top || 0) + sy }); });
        }
        objs.forEach(function (o) { if (o.setCoords) o.setCoords(); });
      }

      /* 统一添加原语（含控制点样式 + 入撤销栈 + 刷新图层）；批量时先不逐个选中 */
      objs.forEach(function (o) {
        if (window.__pfmAddObject) { try { window.__pfmAddObject(o, { noSelect: true }); return; } catch (e) { } }
        c.add(o);
      });
      try {
        if (objs.length > 1 && fabric.ActiveSelection) {
          c.setActiveObject(new fabric.ActiveSelection(objs, { canvas: c }));
        } else if (objs.length === 1) {
          c.setActiveObject(objs[0]);
        }
      } catch (e) { }
      if (c.renderAll) c.renderAll();
      try { if (window.__pfmUpdateFloat) window.__pfmUpdateFloat(); } catch (e) { }
      try { if (window.__pfmUpdateLayers) window.__pfmUpdateLayers(); } catch (e) { }
      toast('Pasted ' + count(objs.length));
    });
  }

  /* section 键盘块据此分发（键位守卫在那边，不重复实现） */
  window.__pfmClipboard = function (k) {
    if (k === 'c') return doCopy(false);
    if (k === 'x') return doCopy(true);
    if (k === 'v') return doPaste();
    return false;
  };

  /* ============================================================ ② 点空白：只收抽屉、不取消选中（2026-09-19，方案 B）
     用户要求：抽屉开着时点画布空白 ⇒ 只把抽屉收起来（好看全画布），**保留图案选中**。
     实现：让 fabric「空点清选择」在「抽屉开着」这一种情况下失效 —— 只覆写原型上的判定函数
     （仅 `!target` 时拦），**不动任何其它逻辑**，也不新增样式。
     ⚠️ 判定必须用「手势开始时抽屉是否开着」：section 的收起处理器挂在 #pfmBoard 的**捕获阶段**，
        比 fabric 早 —— 等 fabric 判定时标记类已经摘掉了。所以本标记挂在 **document 捕获阶段**
        （比 #pfmBoard 更早），记下本次手势起点的状态。
     退路：抽屉收起后再点空白 = 照旧取消选中（标记自然为 false）。
     ⚠️ 2026-09-19 用户选 **C** ⇒ **不提供**「点图案重开抽屉」：抽屉收起后要开，只能点底部对象组的格子。
       （曾实现过一版并被真机打回：fabric 在 **mousedown 阶段**就已把点中的对象设成 active，
         「点到的 === 当前选中」这一判断**恒成立** ⇒ 点任意图案（含首次选中）都会弹抽屉 = 弹「尺寸」。）
  */
  function touchLayout() { try { return !!(window.__pfmTouchLayout && window.__pfmTouchLayout()); } catch (e) { return false; } }
  function propsEl() { return q('pfmProps'); }
  function drawerOpen() { var p = propsEl(); return !!(p && p.classList.contains('pfm-open')); }

  var keepSel = false;                        /* 本次手势开始时抽屉是否打开 */
  function markKeep() { keepSel = touchLayout() && drawerOpen(); }
  document.addEventListener('pointerdown', markKeep, true);
  document.addEventListener('touchstart', markKeep, true);

  var noClearPatched = false;
  function patchNoClear() {
    if (noClearPatched) return;
    try {
      var P = window.fabric && window.fabric.Canvas && window.fabric.Canvas.prototype;
      if (!P || typeof P._shouldClearSelection !== 'function') return;
      var orig = P._shouldClearSelection;
      P._shouldClearSelection = function (e, target) {
        if (!target && keepSel) return false;   /* 抽屉开着 ⇒ 保留选中，只收抽屉 */
        return orig.apply(this, arguments);
      };
      noClearPatched = true;
      window.__pfmKeepSelPatched = true;   /* 自检标记：原型补丁已挂上 */
    } catch (e) { }
  }

  /* ============================================================ ③ 抽屉开合 ⇒ 让画布重算尺寸（2026-09-19）
     抽屉打开时 hd-canvas.css 会给画布区加 padding-bottom（为抽屉留位），而画布尺寸由 section
     从 computed padding 现算（resizeCanvasToPrintArea）—— padding 变化**不会**触发它的 ResizeObserver
     （那个看 border-box 尺寸）。所以在抽屉 class 变化的 40ms 后派发一次 window resize，
     section 的 resize 处理器会 debounce 150ms 后重算 ⇒ 画布缩到不挡衣服的大小。
     只在触控（抽屉）形态下有意义；桌面端派发也无副作用。 */
  function bindDrawerResize() {
    var p = q('pfmProps');
    if (!p || !window.MutationObserver || p.__pfmRsBound) return;
    p.__pfmRsBound = true;
    var t = 0;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { try { window.dispatchEvent(new Event('resize')); } catch (e) { } }, 40);
    }).observe(p, { attributes: true, attributeFilter: ['class'] });
  }

  /* ============================================================ 启动 */
  function bindCanvas(c) {
    if (c.__xfBound) return;
    c.__xfBound = true;
    ['selection:created', 'selection:updated', 'selection:cleared',
     'object:modified', 'object:added', 'object:removed'].forEach(function (ev) {
      try { c.on(ev, function () { syncXf(); }); } catch (e) { }
    });
  }
  function boot() {
    bindXf();
    patchNoClear();
    bindDrawerResize();
    var c = CV();
    if (c) { bindCanvas(c); syncXf(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 1500);   /* board 后开也兜一次（幂等） */

  /* 2026-09-20: 角度快捷胶囊的入口 —— 直接复用 applyXf('a')（**绕中心** + 进撤销栈），
     与在 ∠ 输入框里手输数字走**完全同一条路径**，不写第二份角度逻辑。 */
  function setAngle(deg) {
    var ok = applyXf('a', deg, true);
    try { syncXf(); } catch (e) { }
    return ok;
  }
  window.__pfmEdit = { syncXf: syncXf, copy: doCopy, paste: doPaste, spec: spec, setAngle: setAngle };
})();
